export const examTablePopupsNames = {
  delete: 'delete',
  sendToAdmin: 'sendToAdmin',
  copyAsAdmin: 'copyAsAdmin',
  copyAsTeacher: 'copyAsTeacher',
  denied: 'denied',
  archive: 'archive',
  activate: 'activate',
};
